import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { PauseOutlined, PlayArrowOutlined } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { AgentEvents, BaseAgent } from "../agents/BaseAgent";
import { AgentState } from "../agents/AgentState";
import { RenderAccordionToolbar } from "../../../components/Minibar";

export function AgentStatesList({
  agent,
  pinned,
  panel,
  togglePin,
}: {
  agent: BaseAgent;
  pinned: Set<string>;
  panel: string;
  togglePin: (panel: string) => void;
}) {
  const [states, setStates] = useState<AgentState[]>([]);
  useEffect(() => {
    const updateStates = () => {
      setStates(agent.getStates());
    };
    agent.on(AgentEvents.AgentStateChange, updateStates);
    updateStates();
    return () => {
      agent.off(AgentEvents.AgentStateChange, updateStates);
    };
  }, [agent]);

  return (
    <>
      <RenderAccordionToolbar
        pinned={pinned}
        panel={panel}
        togglePin={togglePin}
      />
      <List>
        {states.map((state) => (
          <ListItem
            key={`${agent.visual._id}-${state.name}`}
            disablePadding
            dense
          >
            <ListItemIcon sx={{ minWidth: "0px", mr: 1 }}>
              {state.active ? (
                <PauseOutlined color="success" />
              ) : (
                <PlayArrowOutlined />
              )}
            </ListItemIcon>
            <ListItemButton
              onClick={() => {
                if (state.active) {
                  agent.disableState(state.name);
                } else {
                  agent.enableState(state.name);
                }
              }}
            >
              <ListItemText primary={state.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </>
  );
}
